import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import config from '@/config'

/**
 *  Allows React Native WebView to navigate between routes without reloading the page
 */
export const useNavigationRequestListener = () => {
    const history = useHistory()

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.origin !== window.location.origin || !event.data.type) {
                return
            }

            if (event.data.type === 'NAVIGATION_REQUEST' && event.data.path) {
                // TODO: Deprecated, reload logic moved to MobileNotifications.tsx -- let's remove this after a while when users have updated their apps
                if (event.data.path.includes('fromMobileNotification=true')) {
                    // For navigation triggered by tapping on the mobile notifications,
                    // we need to reload the page to ensure the latest data, e.g. messages, is fetched
                    window.location.assign(config.appBasename + event.data.path)
                    return
                }

                history.push(event.data.path)
            }
        }

        window.addEventListener('message', handleMessage)

        return () => {
            window.removeEventListener('message', handleMessage)
        }
    }, [history])
}
